import FJUtil from '@src/util/FJUtil.js';

const FJUserUtil = {
    /**
     * @desc 更新window.fjuser.info的绑定的数据
     * @param target - youtube | dropbox...，等
     * @param {access_token, access_data: {}} data
     */
    updateUserAccountState: function (target, data) {
        if (data) {
            if (FJUtil.isLocalhost() && !window.fjuser.info.account_link) {
                window.fjuser.info.account_link = {};
            }

            let userData = data.access_data;
            window.fjuser.info.account_link[target] = {
                isLink: true,
                access_token: data.access_token,
                user_name: userData?.user_name ?? userData?.email,
                email: userData?.email,
            };
            switch (target) {
                case 'tiktok':
                    window.fjuser.info.account_link[target].open_id = userData?.open_id;
                    break;
                default:
                    break;
            }
        } else {
            if (window.fjuser?.info?.account_link) {
                window.fjuser.info.account_link[target] = { isLink: false };
            }
        }
    },
    getAccountDataForUser: function (data, target) {
        return data && data[target] && data[target].isLink
            ? {
                  user_name: data[target].user_name,
              }
            : {
                  user_name: '',
              };
    },
    getAccessTokenWithType: function (type) {
        if (!type) {
            return;
        }
        return window.fjuser?.info?.account_link?.[type]?.access_token;
    },
    getSocialAccountWithType: function (type) {
        if (!type) {
            return;
        }
        return window.fjuser?.info?.account_link?.[type];
    },
};

export default FJUserUtil;
